export default __webpack_public_path__ + "static/media/SAVE_20230713_011735 - Hima.7d62074e.jpg";